/**
 * @file: constants.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const kVehicleBannerHeight = 270;
export const kTaskDetailHeaderHeight = 160;
export const kGeneralHeaderHeight = 160;
export const kScreenContentPadding = 98;
export const kDashboardHeaderHeight = 160;
export const kDashboardToolbarHeight = 80;
export const kDashboardToolbarMarginTop = 42;
export const kDashboardVerticalPadding = 60;
